(function ($) {
    $(".csn-control").each(function() {
    let $this = $(this);
    if ($this.val()) {
      $this
        .addClass("active")
        .next("label")
        .addClass("active");
    }
  });

  $(document.body)
    .on("focus", ".csn-control", function() {
      $(this)
        .addClass("active")
        .next("label")
        .addClass("active");
    })
    .on("blur", ".csn-control", function() {
      let $this = $(this);
      if (!$this.val()) {
        $this
          .removeClass("active")
          .next("label")
          .removeClass("active");
      }
    });
})(jQuery, window);
